import { HELP_REQUEST_MESSAGE_LENGTH, UPLOAD_ERROR_MAP, DELETE_ATTACHMENT_CLASS } from './constants';
import { UploadError } from './typings';

import { attachEventAttachmentDelete, FileUploadReturns, uploadAttachment, Attachment, buildFileuploadForm, buildAndAppendAttachments, toggleUploadProgress } from './helpers/file-upload';
import Toast from './helpers/toast-notification';
import translate from './helpers/translate';
import attachCharacterCounterEvents from './forms/character-counter';
import validateHelprequestForm from './forms/helprequest';
import createBrowserInfoParameters from './helpers/get-browser-info';

function makeHelpRequestAttachmentUpload() {
    const wrapperDiv = document.querySelector<HTMLDivElement>('#attachmentInputs');
    const helpRequestInputFields = wrapperDiv?.querySelectorAll<HTMLInputElement>('input');

    if (!helpRequestInputFields) {
        return;
    }

    const notSubmitted = Array.from(helpRequestInputFields).filter((input: HTMLInputElement) => {
        return input.type === 'file' && !input.disabled;
    });

    if (notSubmitted.length > 0) {
        notSubmitted[0].click();

        return;
    }

    const attachmentsDiv = document.querySelector<HTMLDivElement>('#attachments');
    const attachlist = document.querySelector<HTMLOListElement>('#attachlist');
    const { form, input: fileInput }: FileUploadReturns = buildFileuploadForm('helprequestattachment');

    fileInput.multiple = false; // only allow 1 in helprequest.
    fileInput.accept = '';

    form.addEventListener('change', function (this: HTMLFormElement, e: Event) {
        const formData = new FormData(this);

        fileInput.disabled = true;

        toggleUploadProgress();

        uploadAttachment(form.action, formData)
            .then((newAttachments: Array<Attachment>) => {
                buildAndAppendAttachments(attachmentsDiv, attachlist, newAttachments);

                return newAttachments.pop();
            })
            .then((attachment: Attachment) => {
                const filename = document.querySelector<HTMLInputElement>('input[name="filename"]');
                const randID = document.querySelector<HTMLInputElement>('input[name="randID"]');

                if (!filename || !randID) {
                    return;
                }

                filename.value = attachment.fileName;
                randID.value = `${attachment.randID}`;

                Toast.show({
                    message: translate([804, filename.value]),
                    type: 'success',
                });
            })
            .then(() => {
                wrapperDiv?.removeChild(form);
            })
            .then(() => {
                const attachmentAdd = document.querySelector<HTMLButtonElement>('#addAttachButton');
                attachmentAdd?.classList.add('btn--disabled');
                attachmentAdd?.setAttribute('disabled', 'disabled');
            })
            .catch((error: UploadError) => {
                toggleUploadProgress();

                Toast.show({
                    message: translate(UPLOAD_ERROR_MAP[error[0]]),
                    type: 'error',
                });
            });
    });

    wrapperDiv?.appendChild(form);
    fileInput.click(); // open the input selector.
}

document.querySelector('#addAttachButton')?.addEventListener('click', (e: Event) => {
    makeHelpRequestAttachmentUpload();
});

attachEventAttachmentDelete();
attachCharacterCounterEvents(HELP_REQUEST_MESSAGE_LENGTH);

const attachmentsList: HTMLDivElement | null = document.querySelector('#attachlist');
attachmentsList?.addEventListener('click', (e: Event) => {
    const target: EventTarget | null = e.target;
    if (!(target instanceof HTMLElement && target.closest(DELETE_ATTACHMENT_CLASS) && target.closest(DELETE_ATTACHMENT_CLASS) instanceof HTMLButtonElement)) {
        return;
    }

    const filenameField: HTMLInputElement | null = document.querySelector('input[name="filename"]');
    if (filenameField) {
        filenameField.value = '';
    }
});

// View attachment
function attachEventAttachmentView(): void {
    const form: HTMLFormElement | null = document.querySelector('.js-help-request-attachments');
    const downloadLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.js-view-attachment');

    downloadLinks.forEach((element: HTMLAnchorElement) => {
        element.addEventListener('click', (e: Event) => {
            const attachmentID: string | null = element.getAttribute('data-id');

            if (attachmentID && form) {
                form.attachID.value = attachmentID;
                form.submit();
            }
        });
    });
}

attachEventAttachmentView();
validateHelprequestForm('#help-request-new');
validateHelprequestForm('#help-request');
validateHelprequestForm('#help-request-read');
validateHelprequestForm('#help-request-validate');
createBrowserInfoParameters('#help-request-new', 'help-request');
createBrowserInfoParameters('#help-request-read', 'help-request');
